import { render, staticRenderFns } from "./ConsultantGeneral.vue?vue&type=template&id=f0dfe316&"
import script from "./ConsultantGeneral.vue?vue&type=script&lang=js&"
export * from "./ConsultantGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports